var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.3h-35c-15.1 0-24.2 9-24.2 24.2v35c0 15.1 9 24.2 24.2 24.2h35c15 0 24.1-9 24.1-24.2v-35c0-15.1-9-24.2-24.1-24.2ZM27 38.7a3.1 3.1 0 0 1 0-4.4 14 14 0 0 1 19.5 0 3.1 3.1 0 0 1 0 4.4 3 3 0 0 1-2.2.9 3 3 0 0 1-2.2-1c-3-2.9-7.8-2.9-10.7 0a3 3 0 0 1-4.4 0Zm38 36.6H35c-3 0-5.3-2.3-5.3-5.3a20.4 20.4 0 0 1 40.7 0c0 3-2.5 5.3-5.4 5.3Zm8-36.6a3.1 3.1 0 0 1-4.4 0c-3-3-7.8-3-10.7 0a3 3 0 0 1-2.2.9 3 3 0 0 1-2.2-1 3.1 3.1 0 0 1 0-4.3 14 14 0 0 1 19.5 0 3.1 3.1 0 0 1 0 4.4Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.58002ae1b2fd115d552ee8e22339a23d.svg";
export { ForwardRef as ReactComponent };